import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './set_site_block.component.html'
})
export class SetSiteBlockModalComponent extends BaseSupportModalComponent {
	title: string;
	siteId: string;
	userEmail: string;
	domainUrl: string;
	message: string;

	ngOnInit() {
		this.message = `Ваш сайт ${this.domainUrl} содержит запрещенный контент.`;
	}

	async ok() {
		if (confirm(`Вы уверены, что хотите заблокировать сайт ${this.domainUrl}?`)) {
			await this.supportService.setSiteBlock(this.siteId, this.message, this.spreader.base.comment).toPromise();

			this.execute();
		}
	}
}
